export const TOAST_FIXED_WIDTH = '600px';
